'use client';

import React from 'react';
import { MotionDiv } from '@/components/motion';

export default function LocationMap() {
  return (
    <MotionDiv 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.3 }}
      className="w-full h-full"
    >
      {/* 
        In a production environment, you would load the Google Maps API here with your API key
        For example:
        <GoogleMap
          bootstrapURLKeys={{ key: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY }}
          defaultCenter={{ lat: -33.4372, lng: -70.6506 }}
          defaultZoom={15}
        >
          <Marker lat={-33.4372} lng={-70.6506} />
        </GoogleMap>
      */}
      
      {/* Fallback for development/preview: an iframe with Google Maps */}
      <iframe 
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d16534.470406651213!2d-58.5246969239073!3d-34.68362125345124!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcc8dac1d48bc1%3A0xeeb3d43d7c7a5f5d!2sDroquimar!5e0!3m2!1ses!2sar!4v1752353463500!5m2!1ses!2sar"
        width="100%" 
        height="100%" 
        style={{ border: 0 }} 
        allowFullScreen
        loading="lazy"
        title="Ubicación de Droquimar"
        className="rounded-lg"
      />
    </MotionDiv>
  );
} 